<template>
  <div class="container flex" style="margin-bottom: 20px;">
    <left></left>
    <div class="live flex1" style="margin-left: 20px;">
    	<div class="title flex padding-15">
    		老师答疑 - 我的提问 - <span style="color: #4fa7ff;">答疑详情</span>
    		<span class="flex1"></span>
    		<span class="font16" style="color: #4fa7ff;cursor: pointer;" @click="handleBack">返回</span>
    	</div>
    	<div class="content" style="padding: 20px;line-height: 1.8;">
    		<div class="" style="font-weight: bold;">
    			{{data.answerQuestionsTitle}}
    		</div>
    		<div class="font14 insert" style="word-break: break-all;">
    			{{data.answerQuestionsContent}}
    		</div>
    		<div class="imglist margin-t-10" v-if="data.answerPics">
    			<img :src="item" class="pic" v-for="item in data.answerPics" >

    		</div>
    		<template v-if="data.replyContent">
    		  <div class="line">

    		  </div>
    		  <div class="" v-if="data.replyContent">
    		  	老师回复
    		  </div>
    		  <div class="font14" v-html="data.replyContent" v-if="data.replyContent">
    		  	问题描述企业每季度预计期末产成品存货为下一季度预计销量的10%,已知第二季度预计销售量为2000件,第三季度预计销售量为2200件,则第二季度产成品预计产量()件
    		  </div>
    		</template>
    		<div class="line">

    		</div>
  <!--  		<div class="" style="color: #4fa7ff;">
    			追问
    		</div>
    		<div class="font14">
    			问题描述企业每季度预计期末产成品存货为下一季度预计销量的10%,已知第二季度预计销售量为2000件,第三季度预计销售量为2200件,则第二季度产成品预计产量()件
    		</div>
    		<div class="line">

    		</div> -->

        <template v-if="isshow">
          <div class="" style="">
          	<textarea rows="" cols="" placeholder="说点儿什么" v-model="content"></textarea>
          </div>
          <div class="text-right" style="">
          	<span class="btn" @click="handleSubmit()" style="cursor: pointer;">追问</span>
          </div>
        </template>
    		<div class="commentlist" style="">
    			<div class="flex algin-center" style="margin-bottom: 30px;">
    				<span>全部追问</span>
    				<span class="font14 text-gray margin-l-10">{{replayList.list}}</span>
    			</div>
    			<template v-for="item in replayList">
    			  <div class="list">
    			  <!-- 	<img src="../assets/img/cover.png" class="avator" > -->
    			  	<div class="right">
    			  		<div class="nickname" style="color: rgb(79, 167, 255);">
    			  			学生追问
    			  		</div>
    			  		<div class="font14 text-gray margin-t-5">
    			  			{{item.answerQuestionsContent}}
    			  		</div>
    			  		<div class="datetime">
    			  			{{item.submitTime}}
    			  		</div>
    			  	</div>
              <template v-if="item.replyContent">
                <div class="right">
                	<div class="nickname">
                		老师答复
                	</div>
                	<div class="font14 text-gray margin-t-5" v-html="item.replyContent">

                	</div>
                	<div class="datetime">
                		{{item.replyTime}}
                	</div>
                </div>
              </template>
    			  </div>
    			  <div class="line">

    			  </div>
    			</template>


    		</div>
    	</div>
    </div>

  </div>
</template>

<script>
  import left from './left.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          data:'',
          answerQuestionsId:this.$route.query.id,
          content:'',
          replayList:[],
          isshow:false
      }
    },
    methods:{
      getData(){
        this.$axios.get(this.$common.questions_detail+'?answerQuestionsId='+this.answerQuestionsId).then((res)=>{
              if(res.data.code==1){
                this.data=res.data.data;
                this.isshow=res.data.data.myTag

              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleSubmit(){
          if(this.content==''){
            alert('请输入内容')
            return;
          }
          let data=new FormData();
              data.append('answerQuestionsId',this.answerQuestionsId);
              data.append('content',this.content);
          this.$axios.post(this.$common.questions_studentReply,data).then((res)=>{
                if(res.data.code==1){
                    this.content='';
                    this.getReplyList();
                }
                else {
                  alert(res.data.msg)
                }
          })
      },
      handleBack(){
        this.$router.go(-1)
      },
      getReplyList(){
        this.$axios.get(this.$common.questions_answerQuestionsReplyList+'?answerQuestionsId='+this.answerQuestionsId).then((res)=>{
              if(res.data.code==1){
                this.replayList=res.data.data;

              }
              else {
                alert(res.data.msg)
              }
        })
      }
    },
    created(){
      this.getData();
      this.getReplyList();
    }
  }
</script>

<style scoped>
  .live .title {
  	line-height: inherit;
  }
  .pic {
  	width: 230px;
  	height: 140px;
  	margin-right: 15px;
  	object-fit: contain;
  }
  .line {
  	height: 1px;
  	background-color: #ccc;
  	margin: 15px 0;
  }
  textarea {
  	width: 100%;
  	height: 112px;
  	font-size: 14px;
  	background-color: #f4f4f4;
  	border: 1px solid #ccc;
  	text-indent: 15px;
  	padding: 15px 0;
  	outline: none;
  }
  .btn {
  	width: 100px;
  	height: 40px;
  	text-align: center;
  	display: inline-block;
  	background-color: #fff;
  	line-height: 40px;
  	font-size: 14px;
  	background-color: #4fa7ff;
  	color: #fff;
  	border-radius: 4px;
  	margin-top: 15px;
  }
  .commentlist .list {
  	display: block;
  }
  .commentlist .line {
  	margin: 30px 0;
  }
  .avator {
  	width: 50px;
  	height: 50px;
  	border-radius: 50%;
  	margin-right: 10px;
  }
  .datetime {
  	font-size: 14px;
  	color: #aaaaaa;
  	margin-top: 5px;
  }
  textarea {
    border: none;
    background-color: #F8F8F8;
  }
  .live .list{
    padding-left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/questiondetail.vue